export default __webpack_public_path__ + "static/media/collateralIcon.ec3bad87.svg";